import React from "react";
import "./LeaderShip.css";
function LeaderShip() {
  return (
    <React.Fragment>
      <div className="LeaderShipWrapper">
        <div className="LeaderShipHeading">Leadership</div>
        <div className="LeaderShipGridLayout">
          <div className="LeaderShipLeaderIcon">
            <div className="LeaderShipImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/rahm_YE9yFiZR0.png"
                alt="Rahm Shastry"
                loading="lazy"
                width={"100%"}
                height={"100%"}
              />
            </div>
            <div className="LeaderShipName">Rahm&nbsp;Shastry</div>
            <div className="LeaderShipRole">Executive Chairman and CFO</div>
            <a
              href="https://www.linkedin.com/in/rahm-shastry-18586/"
              style={{ width: "10%" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://ik.imagekit.io/driveu/Web/linkedin_jDwoKZiNj.png"
                width={"100%"}
                height={"100%"}
                alt="Rahm Shastry"
                loading="lazy"
              />
            </a>
          </div>
          <div className="LeaderShipLeaderIcon">
            <div className="LeaderShipImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/ashok_xJ1p5fcWr.png"
                alt="Ashok Shastry"
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="LeaderShipName">Ashok&nbsp;Shastry</div>
            <div className="LeaderShipRole">CEO & Co-founder</div>
            <a
              href="https://www.linkedin.com/in/anshastry/"
              style={{ width: "10%" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://ik.imagekit.io/driveu/Web/linkedin_jDwoKZiNj.png"
                width={"100%"}
                height={"100%"}
                alt="Ashok Shastry"
                loading="lazy"
              />
            </a>
          </div>
          <div className="LeaderShipLeaderIcon">
            <div className="LeaderShipImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Parvez_photo_C7Hj-KcDS.jpg?updatedAt=1680761707158"
                alt="Parvez Ali"
                style={{ borderRadius: "50%" }}
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="LeaderShipName">Parvez&nbsp;Ali</div>
            <div className="LeaderShipRole">
              Business Unit Head- New Verticals
            </div>
            <a
              href="https://www.linkedin.com/in/aliparvez212/"
              style={{ width: "10%" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://ik.imagekit.io/driveu/Web/linkedin_jDwoKZiNj.png"
                width={"100%"}
                height={"100%"}
                alt="Parvez Ali"
                loading="lazy"
              />
            </a>
          </div>
          <div className="LeaderShipLeaderIcon">
            <div className="LeaderShipImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/Anand_v232m26JI.png"
                alt="Anand E."
                style={{ borderRadius: "50%" }}
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="LeaderShipName">Anand E.</div>
            <div className="LeaderShipRole">Director,&nbsp;Operations</div>
            <a
              href="https://www.linkedin.com/in/anand-e-01115837/"
              style={{ width: "10%" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://ik.imagekit.io/driveu/Web/linkedin_jDwoKZiNj.png"
                width={"100%"}
                height={"100%"}
                alt="Anand E"
                loading="lazy"
              />
            </a>
          </div>
          <div className="LeaderShipLeaderIcon">
            <div className="LeaderShipImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/Abhay_ZJz8DJSPc.png"
                alt="Abhay Kumar"
                style={{ borderRadius: "50%" }}
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="LeaderShipName">Abhay Kumar</div>
            <div className="LeaderShipRole">Director, Customer Success</div>
            <a
              href="https://www.linkedin.com/in/abhay-kumar-2b2a73127/"
              style={{ width: "10%" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://ik.imagekit.io/driveu/Web/linkedin_jDwoKZiNj.png"
                width={"100%"}
                height={"100%"}
                alt="Abhay Kumar"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default LeaderShip;
